import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentCard } from '@core/models/payment-card.model';
import { UserSubscription } from '@core/models/subscription.model';
import { CurrentMonthlySpend, ScheduledMessage } from '@core/models/user.model';
import { Observable } from 'rxjs';
import { API_LIST } from '../web-api/api-list';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  getScheduledMessages(): Observable<ScheduledMessage[]> {
    return this.httpClient.get<ScheduledMessage[]>(
      API_LIST.getScheduledMessages()
    );
  }

  patchScheduledMessages(slug: string): Observable<void> {
    return this.httpClient.patch<void>(API_LIST.patchScheduledMessages(slug), {
      readConfirmed: true
    });
  }

  getCurrentMonthlySpend(): Observable<CurrentMonthlySpend> {
    return this.httpClient.get<CurrentMonthlySpend>(
      API_LIST.getCurrentMonthlySpend()
    );
  }

  getCurrentPaymentCads(
    thirdService: string | null = 'checkout'
  ): Observable<PaymentCard[]> {
    return this.httpClient.get<PaymentCard[]>(
      API_LIST.getPaymentCards(thirdService)
    );
  }

  getUserGameTicketsCount(slug: string): Observable<{ value: number }> {
    return this.httpClient.get<{ value: number }>(
      API_LIST.getUserGameTicketsCount(slug),
      {}
    );
  }

  getUserSubscriptions(params: any = {}): Observable<UserSubscription[]> {
    return this.httpClient.get<UserSubscription[]>(
      API_LIST.getUserSubscriptions(),
      { params }
    );
  }

  getUserSubscription(id: number): Observable<UserSubscription> {
    return this.httpClient.get<UserSubscription>(
      API_LIST.getUserSubscription(id)
    );
  }

  cancelUserSubscription(id: number): Observable<void> {
    return this.httpClient.delete<void>(API_LIST.cancelUserSubscription(id));
  }

  patchUserSubscription(id: number, data: any): Observable<UserSubscription> {
    return this.httpClient.patch<UserSubscription>(
      API_LIST.patchUserSubscription(id),
      data
    );
  }

  getHistoryOrders(): Observable<any> {
    return this.httpClient.get<any>(API_LIST.getUserOrders());
  }

  getDetailedOrder(id: string): Observable<any> {
    return this.httpClient.get<any>(
      API_LIST.getUserOrderDetailedPayment(id, '')
    );
  }
}
